//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import accountForm from './accountForm.vue';
import { validatePass, typeOptions, statusOptions } from './common';
let number2timeId = null;
export default {
  components: {
    accountForm,
  },
  data() {
    return {
      // 表单
      searchForm: {
        page: 1,
        page_size: 10,
      },
      // 表格
      loading: false,
      list: [],
      total: 0,
      // 修改密码
      passWordVisible: false,
      changePassWordUin: null,
      passWord: {
        number1: '',
        number2: '',
      },
      passWordRules: {
        number1: [
          { required: true, message: '请输入密码', trigger: 'change' },
          {
            validator: validatePass,
            trigger: 'change',
          },
        ],
        number2: [
          { required: true, message: '请输入密码', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (number2timeId) {
                clearTimeout(number2timeId);
              }
              number2timeId = setTimeout(() => {
                if (this.passWord.number1 !== this.passWord.number2) {
                  callback(new Error('密码不一致'));
                } else {
                  callback();
                }
              }, 300);
            },
            trigger: 'change',
          },
        ],
      },
      // 修改状态
      statusVisible: false,
      changeStatusForm: {
        uin: null,
        status: null,
      },
      statusOptions,
      typeOptions,
      // 弹窗
      accountDialog: {
        show: false,
        uin: '',
        type: 'view',
      },
      // 解绑
      bindingConfig: {
        visible: false,
        row: {},
        third_party: '0',
      },
      bindingOptions: {
        0: 'unkown',
        1: '订阅号',
        2: '服务号',
        3: '小程序',
        4: '腾会应用',
        5: '企业微信',
        6: '手机号',
      },
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      return {
        changePassword: this.getElementList.includes('change-password'),
        unbindApp: this.getElementList.includes('unbind-app'),
        createAccount: this.getElementList.includes('create-account'),
      };
    },
  },
  created() {
    this.getList();
  },
  methods: {
    searchList() {
      this.searchForm.page = 1;
      this.getList();
    },
    resetForm() {
      this.searchForm = {
        page: 1,
        page_size: 10,
      };
      this.searchList();
    },
    async getList() {
      this.loading = true;
      const { name, account, uin, phone, email } = this.searchForm;
      try {
        const { data, total } = await this.$request({
          url: this.$api.AccountGetUserList,
          data: {
            ...this.searchForm,
            name: name || undefined,
            account: account || undefined,
            uin: uin || undefined,
            phone: phone || undefined,
            email: email || undefined,
          },
        });
        this.list = data;
        this.total = total;
        this.loading = false;
      } catch (err) {
        this.list = [];
        this.loading = false;
      }
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.searchForm.page_size = val;
      this.searchForm.page = 1;
      this.getList();
    },
    openDialog({ uin, type }) {
      if (uin) {
        this.accountDialog.uin = uin;
      }
      this.accountDialog.type = type;
      this.$nextTick(() => {
        this.accountDialog.show = true;
      });
    },
    refresh() {
      this.accountDialog.show = false;
      this.searchList();
    },

    // 修改密码
    openPassWord({ uin }) {
      this.changePassWordUin = uin;
      this.passWordVisible = true;
    },
    closePassWord() {
      this.passWordVisible = false;
      this.$nextTick(() => {
        this.$refs.passWordForm.resetFields();
      });
    },
    changePassWord() {
      this.$refs.passWordForm.validate(async (valid) => {
        if (!valid) {
          return;
        }
        try {
          await this.$request({
            url: this.$api.AccountUpdateUserPassword,
            data: { uin: this.changePassWordUin, password: this.passWord.number2 },
          });
          this.closePassWord();
          this.getList();
        } catch (err) {
          console.log(err);
        }
      });
    },
    // 修改状态
    openStatus({ status, uin }) {
      this.changeStatusForm.uin = uin;
      this.changeStatusForm.status = status;
      this.$nextTick(() => {
        this.statusVisible = true;
      });
    },
    closeStatus() {
      this.statusVisible = false;
    },
    async changeStatus() {
      try {
        await this.$confirm(
          `确认修改uin: ${this.changeStatusForm.uin} 的状态为:${
            this.statusOptions[this.changeStatusForm.status]
          }?`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        );
        const res = await this.$request({
          url: this.$api.AccountUpdateUserStatus,
          data: { uin: this.changeStatusForm.uin, status: this.changeStatusForm.status },
        });
        res?.msg && this.$message.error(res.msg);
        this.closeStatus();
        this.getList();
      } catch (err) {
        console.log(err);
      }
    },
    // 解绑
    openBinding(row) {
      this.bindingConfig.row = row;
      this.bindingConfig.visible = true;
    },
    closeBinding() {
      this.bindingConfig.visible = false;
    },
    async changeBinding() {
      try {
        await this.$confirm(`确定解绑账号:${this.bindingConfig.row.uin}?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        await this.$request({
          url: this.$api.unbindUserAppByUin,
          data: {
            uin: this.bindingConfig.row.uin,
            third_party: this.bindingConfig.third_party,
          },
        });
        this.$message({
          message: '解绑成功',
          type: 'success',
        });
        this.bindingConfig.visible = false;
        this.getList();
      } catch (err) {
        console.log(err);
      }
    },
  },
};
